import { CheckboxElement } from 'react-hook-form-mui';

import type { ReactNode } from 'react';

import { translateErrorMessage } from 'Common/Form/FormConsts';

type Props = {
  name: string;
  label: string | ReactNode;
  disabled?: boolean;
};

export const CheckboxField = ({ name, label, disabled }: Readonly<Props>) => (
  <CheckboxElement
    name={name}
    label={label}
    parseError={translateErrorMessage}
    disabled={disabled}
  />
);
